import script from "./licenseInfo.linux.vue?vue&type=script&lang=ts&setup=true"
export * from "./licenseInfo.linux.vue?vue&type=script&lang=ts&setup=true"

import "./licenseInfo.linux.vue?vue&type=style&index=0&id=02865b46&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02865b46"]])

export default __exports__